import React, { useState, ReactElement } from "react";
import { RoundButton } from "./StyledComp";
import "../../Styles/StyledComps.css";

interface IProps {
  icon?: ReactElement;
  buttontext?: string;
  onClick: () => void;
  disabled?: boolean;
}

const RoundButtonWithIcon: React.FC<IProps> = (props) => {
  const handleOnClick = () => {
    props.onClick();
  };

  return (
    <RoundButton
      // className="button-wrapper"
      type="submit"
      onClick={handleOnClick}
      disabled={props.disabled}
    >
      <span className="button-icon">{props.icon}</span>
      <span>{props.buttontext}</span>
    </RoundButton>
  );
};

export default RoundButtonWithIcon;
